import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Zap, ArrowRight } from 'lucide-react';
/**
 * MobileStickyCTA — drijvende CTA-knop onderaan op mobiel, verschijnt
 * na de hero. Verbetert conversie zonder de desktop te storen.
 */
export function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      // verschijnt na ~600px scroll, verdwijnt bij de aanmeld-sectie
      const y = window.scrollY;
      const aanmelden = document.getElementById('aanmelden');
      const aanmeldenTop = aanmelden ? aanmelden.getBoundingClientRect().top + window.scrollY : Infinity;
      setVisible(y > 600 && y < aanmeldenTop - 400);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-507">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="md:hidden fixed bottom-4 left-4 right-4 z-40" data-id="element-508">
          <a href="#aanmelden" className="flex items-center justify-center gap-2 bg-slate-900 text-white rounded-2xl font-bold px-6 py-4 text-base shadow-[0_8px_0_0_rgb(15,23,42),0_20px_40px_-12px_rgba(15,23,42,0.5)] active:translate-y-[2px] active:shadow-[0_6px_0_0_rgb(15,23,42)] transition-transform" data-id="element-509">
            <Zap className="w-4 h-4 text-orange-400" strokeWidth={3} data-id="element-510" />
            Word vroege tester
            <ArrowRight className="w-4 h-4" data-id="element-511" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}